export default __webpack_public_path__ + "f42be28a1a26aec2441488502c4494e9.svg";